import Vue from "vue";
import Vuex from "vuex";

import apiFactory from "../api/factory";
import factory from "./factory";
import { organizationFactory } from "./organization";

import address from "./address";
import application from "./application";
import coreTeam from "./coreTeam";
import definition from "./definition";
import { featureFlagModule } from "./featureFlagModule";
import { organizationApi } from "@/api/organization";
import { organizationAdminApi } from "@/api/organization";
import organizationStatus from "@/store/organizationStatus";
import salesforce from "./salesforce";
import securityStoreMap from "./security";
import clarityStoreMap from "./clarity";
import session from "./session";
import userFactory from "./user";

Vue.use(Vuex);

const file2Api = apiFactory("file2");
const grantApi = apiFactory("grant");
const interfaceApi = apiFactory("interface");
const locationApi = apiFactory("location");

const file2 = factory("id", file2Api);
const grant = factory("id", grantApi);
// Note: this variable declaration breaks the pattern because "interface" is a reserved word
const interfaceStore = factory("interfaceId", interfaceApi);
const location = factory("locationId", locationApi);

const store = new Vuex.Store({
  modules: {
    address,
    application,
    attribute: factory(null, apiFactory("attribute")),
    coreTeam,
    definition,
    department: factory("departmentId", apiFactory("department")),
    device: factory("deviceId", apiFactory("device")),
    departmentPreset: factory("departmentId", apiFactory("departmentPreset")),
    elementType: factory("id", apiFactory("elementType")),
    entity: factory("name", apiFactory("entity")),
    extract: factory("extractId", apiFactory("extract")),
    event: factory("id", apiFactory("event")),
    featureFlag: featureFlagModule,
    file2,
    fileType: factory("id", apiFactory("fileType")),
    grant,
    interface: interfaceStore,
    location,
    milestone: factory("name", apiFactory("admin/milestone")),
    milestoneOrganization: factory("name", apiFactory("milestone")),
    option: factory("optionId", apiFactory("option")),
    organization: organizationFactory(organizationApi),
    organizationAdmin: organizationFactory(organizationAdminApi),
    organizationStatus,
    resource: factory("id", apiFactory("resource")),
    resourceAttribute: factory("name", apiFactory("resourceAttribute")),
    resourceEpicMapping: factory("id", apiFactory("resourceEpicMapping")),
    resourcePreset: factory("id", apiFactory("resourcePreset")),
    salesforce,
    session,
    user: userFactory(apiFactory("user")),
    userAttribute: factory("name", apiFactory("userAttribute")),
    userEpicMapping: factory("id", apiFactory("userEpicMapping")),
    userPreset: factory("id", apiFactory("userPreset")),
    ...clarityStoreMap,
    ...securityStoreMap,
  },
});

const ochinCoreTeamRoles = [
  "ochinInstallAnalyst",
  "ochinInstallSupportAnalyst",
  "ochinProjectCoordinator",
  "ochinProjectManager",
  "ochinProjectSponsor",
  "ochinRevenueCycleAnalyst",
];

store.dispatch("session/init");

for (const coreTeamRole of ochinCoreTeamRoles) {
  store.watch(
    state => {
      if (state.organization.record) {
        return state.organization.record[coreTeamRole];
      }
    },
    username => {
      store.dispatch("coreTeam/getOchinCoreTeamUser", {
        username,
        coreTeamRole,
      });
    }
  );
}

export default store;
